import { IContractData, IStrikeData } from "../../../types";
import TrendingTable from "../../StrategyBuilder/table";
import { useEffect, useState } from "react";
import DropdownButton from "react-bootstrap/DropdownButton";
import { Dropdown } from "react-bootstrap";
import React from 'react';

interface TrendingProps {
  dataSource: IStrikeData[];
  expiries: string[];
  expiry: string;
  selectedExpiry: (exp: string) => void;
}

export default ({ dataSource, expiries, expiry, selectedExpiry }: TrendingProps) => {
  const [rerender, setRerender] = useState(false);
  const filteredData = dataSource.filter((val) => val.expiryDates === expiry);
  const renderField = (value1: any, value2: any) => {
    if (window.screen.width > 500) {
      return (
        <div style={{ display: "flex" }}>
          <div style={{ padding: "0px 5px" }}>{value1}</div>
          <div>{value2}</div>
        </div>
      );
    } else {
      return (
        <>
          <div>{value1}</div>
          <div>{value2}</div>
        </>
      );
    }
  };
  const fields = [
    {
      text: "Strike Price",
      field: "strikePrice",
      render: (value: any) => {
        return (
          <span
            className={
              value.type === "Call" ? "table-row-call" : "table-row-put"
            }
          >
            {value.strikePrice + " " + (value.type === "Call" ? "CE" : "PE")}
          </span>
        );
      },
    },
    {
      text: "LTP",
      field: "lastPrice",
      render: (value: any) =>
        renderField(`${value.lastPrice},`, `${Math.round(value.pchange)}%`),
    },
    // {
    //   text: "Expiry",
    //   field: "expiryDate",
    // },
    {
      text: "Volume",
      field: "totalTradedVolume",
    },
    {
      text: "OI Change",
      field: "pchangeinOpenInterest",
      render: (value: any) => {
        const OIBuildup = findOIBuildUp(value);
        return (
          <div>
            {renderField(
              `${value.changeinOpenInterest},`,
              `${Math.round(value.pchangeinOpenInterest)}%`
            )}
            <div
              className={
                OIBuildup === "Long Buildup" || OIBuildup === "Short Covering"
                  ? "Long-OI-Buildup"
                  : "Short-OI-Buildup"
              }
            >
              {OIBuildup}
            </div>
          </div>
        );
      },
    },
  ];

  const findOIBuildUp = (contractData: IContractData) => {
    if (contractData.changeinOpenInterest >= 0 && contractData.pChange >= 0)
      return "Long Buildup";
    if (contractData.changeinOpenInterest >= 0 && contractData.pChange < 0)
      return "Short Buildup";
    if (contractData.changeinOpenInterest < 0 && contractData.pChange >= 0)
      return "Short Covering";
    return "Long Unwinding";
  };

  const handleOrientationChange = () => {
    setRerender(!rerender);
  };

  const data = filteredData
    .flatMap((val) => [
      { ...val.CE, type: "Call" },
      { ...val.PE, type: "Put" },
    ])
    .filter((val) => val !== undefined && val.totalTradedVolume !== undefined)
    .sort((a, b) => b!.totalTradedVolume! - a!.totalTradedVolume!)
    .slice(0, 10);

  useEffect(() => {
    window.addEventListener("orientationchange", handleOrientationChange);
    return () => {
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, [rerender]);
  return (
    <div style={{textAlign: 'center'}}>
      <p
        className="text-secondary"
        style={{ marginLeft: "10px", marginBottom: "0px" }}
      >
        A list of top 10 active contracts for expiry
      </p>
      <DropdownButton
        id="dropdown-basic-button"
        title={expiry}
        size="sm"
        variant="success"
      >
        {expiries.map((val, index) => {
          return (
            <Dropdown.Item
              key={index}
              onSelect={() => {
                selectedExpiry(val);
              }}
            >
              {val}
            </Dropdown.Item>
          );
        })}
      </DropdownButton>
      <TrendingTable dataSource={data} fields={fields} showRemoveIcon={false} />
    </div>
  );
};
